<script>
export default {
    layout: 'layout-guest',

    methods: {
        getName() {
            return process.env.VUE_APP_NAME
        },
    },
}
</script>

<template lang="pug">
    .card.p-5(style="max-width: 30rem;")
        acrm-heading.text-center(wide) {{ getName() }}
        acrm-heading.text-center(:level="4") {{ $t('AUTH.FORGOTPASS.HEAD') }}
        small.text-center {{ $t('AUTH.FORGOTPASS.HELP') }}
        acrm-forgot-password-form
        .text-center
            router-link(to="/") {{ $t('BASE.BACK') }}
</template>
